/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Mk_Calc_Seats_ValueInputs */

const en_mk_calc_seats_value = /** @type {(inputs: Mk_Calc_Seats_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} people`)
};

const id_mk_calc_seats_value = /** @type {(inputs: Mk_Calc_Seats_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} orang`)
};

/**
* | output |
* | --- |
* | "{n} people" |
*
* @param {Mk_Calc_Seats_ValueInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_calc_seats_value = /** @type {((inputs: Mk_Calc_Seats_ValueInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Calc_Seats_ValueInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_calc_seats_value(inputs)
	return en_mk_calc_seats_value(inputs)
});